var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nets)?_c('v-container',{staticClass:"grey lighten-5",attrs:{"fluid":""}},[_c('nets-filters',{attrs:{"nets":_vm.nets}}),_c('time-series-graph'),_c('chart-options')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }